import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import UnitCard from '../../../../../components/UnitCard';
import FinishSessionButton from '../FinishSessionButton/FinishSessionButton';
import * as Styled from './UnitCompleteNext.styled';

const UnitCompleteNext = ({ nextUnit, courseID }) => {
  const handleOnClick = useCallback((urlObject) => {
    var event = new CustomEvent('onVHSessionCompleteAndUserContinued', {
      detail: {
        nextUnitPath: `${urlObject.pathname}?${urlObject.search}`,
      },
    });
    // in iframe, so call parent document's dispatch
    window.parent.document.dispatchEvent(event);
  }, []);

  return (
    <Styled.UnitCompleteNextWrapper>
      <div>Congratulations! You have completed the unit.</div>
      {nextUnit && (
        <Styled.UnitCompleteNextUnit>
          <div>Click the next unit to proceed.</div>
          <UnitCard
            onClick={handleOnClick}
            unit={nextUnit}
            courseID={courseID}
          />
        </Styled.UnitCompleteNextUnit>
      )}
      {!nextUnit && courseID && <FinishSessionButton courseID={courseID} />}
    </Styled.UnitCompleteNextWrapper>
  );
};

UnitCompleteNext.propTypes = {
  nextUnit: PropTypes.object,
  courseID: PropTypes.string,
};

export default UnitCompleteNext;
